import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";

// Slice
const initialState = {
  data: {
    office_space_detail: {
              _option: '',
              place_option: ''
            },
    related_businesses: []
    }, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'OfficeSpaceOtherBusinessDetails/fetch', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/office_space?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log(initialState);
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return rejectWithValue(error.message)
      }
  })


// Create New State
export const SubmitOfficeSpaceOtherBusinessDetails = createAsyncThunk(
    'OfficeSpaceOtherBusinessDetails/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        try {
          const {token, currentStep} = getState().navigator;

          if (currentStep === 13 && data.office_space_detail.place_option === '' ) {
            return rejectWithValue('Please select the option.');
          }

          if (currentStep === 14 && data.office_space_detail._option === '' ) {
            return rejectWithValue('Please select the option.');
          }

          if (currentStep === 14 && data.office_space_detail._option === 'Yes' && data.related_businesses.length === 0 ) {
            // console.log('Please add at least one business, otherwise select "No"')
            return rejectWithValue('Please add at least one business, otherwise select "No"');
          }

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/office_space?token=${token}`, {
              method: 'POST',
              body: JSON.stringify({'data': data, 'current_step': currentStep}),
              headers: {
                'Content-Type': 'application/json',
            }
          });
          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return rejectWithValue(error.message);
        }
      }
)



// submit business details
export const SubmitBusinessDetails = createAsyncThunk(
  'BusinessDetails/submit',
  async (data, { getState, dispatch, rejectWithValue }) => {
      try {
        const {token} = getState().navigator;
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/office_space_add_business?token=${token}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
          }
        });
        const response_data =  await response.json();
        // Handle the response data
        // console.log('Form submitted successfully', response_data);
  
        return response_data.data;
      } catch (error) {
        // Handle submission errors
        console.error('Form submission error', error);
        // Throw an error for the rejected action
        return rejectWithValue(error.message);
      }
    }
)

// UPDATE business details
export const updateBusinessDetails = createAsyncThunk(
  'BusinessDetails/update', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/office_space_add_business?token=${token}`, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                  'Content-Type': 'application/json',
              }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const updated_data = await response.json();
        // console.log(updated_data);
        return updated_data.data;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return rejectWithValue(error.message)
      }
  })



  // DELETE Business
export const deleteBusinessDetails = createAsyncThunk(
  'BusinessDetails/delete', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    const {token} = getState().navigator;
      try {
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/delete_business?token=${token}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                }
          });
          if (!response.ok) {
            throw new Error('Failed to fetch initial state');
          }
          const response_data = await response.json();
          // console.log(response_data);
          return response_data.data;
      } catch (error) {
          console.error('Error fetching initial state:', error);
          return rejectWithValue(error.message)
      }
    
  })

export const officeSpaceOtherBusinessDetailsSlice = createSlice({
    name: 'OfficeSpaceOtherBusinessDetails',
    initialState,
    reducers: {
      updateOfficeSpaceOtherBusinessOption: (state, action) => {
          state.data.office_space_detail._option = action.payload;
      },
      updateOfficeSpaceOtherBusinessPrivatePlace: (state, action) => {
          state.data.office_space_detail.place_option = action.payload;
      }
    },
    extraReducers: (builder) => {
        builder
          // FETCH
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            // console.log(action.payload);
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE or UPDATE
          .addCase(SubmitOfficeSpaceOtherBusinessDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitOfficeSpaceOtherBusinessDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitOfficeSpaceOtherBusinessDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE Business or UPDATE
          .addCase(SubmitBusinessDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitBusinessDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitBusinessDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // UPDATE
          .addCase(updateBusinessDetails.pending, (state) => {
              state.loading = true;
          })
          .addCase(updateBusinessDetails.fulfilled, (state, action) => {
              state.loading = false;
              // let index = state.data.related_businesses.findIndex(obj => obj.id === action.payload.id);
              // // Replace the object if it exists
              // if (index !== -1) {
              //     state.data.related_businesses[index] = action.payload;
              // }
              state.data = action.payload;
          })
          .addCase(updateBusinessDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // DELETE
          .addCase(deleteBusinessDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(deleteBusinessDetails.fulfilled, (state, action) => {
            state.loading = false;
            // let index = state.data.related_businesses.findIndex(obj => obj.id === action.payload.id);
            // // Delete the object if it exists
            // if (index !== -1) {
            //     state.data.related_businesses.splice(index, 1);
            // }
            state.data = action.payload;
          })
          .addCase(deleteBusinessDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateOfficeSpaceOtherBusinessOption, updateOfficeSpaceOtherBusinessPrivatePlace } = officeSpaceOtherBusinessDetailsSlice.actions;

export default officeSpaceOtherBusinessDetailsSlice.reducer;
  